module.exports = __webpack_public_path__ + "img/agency_img_2.dbf1c2b8.png";